module.exports = __webpack_public_path__ + "img/plus.572a0e13.svg";